export default function validateTextRequired(value: any, attributes: { required?: boolean }) {
  if (!attributes || !attributes.required) return true;
  const isValid = !(
    value === null
    || value === undefined
    || value === ""
    || (typeof value === "string" && value.trim().length === 0)
  );
  return isValid;
}
